export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '黑料网是什么？',
    answer: '黑料网是国内领先的资讯爆料平台，致力于为读者提供最新、最全的社会热点、娱乐圈动态、科技资讯、财经分析等内容。我们坚持独立客观的报道立场，深入挖掘事件真相，为公众呈现不为人知的内幕信息。',
  },
  {
    question: '为什么黑料网经常更换域名？',
    answer: '由于黑料网报道的内容涉及社会敏感话题和揭露性报道，部分内容可能会触及相关利益方的敏感神经，导致域名遭遇恶意举报或DNS污染。为确保读者能够持续稳定地访问，我们会定期更新备用域名，建议您收藏本页以获取最新可用地址。',
  },
  {
    question: '如何获取黑料网最新可用域名？',
    answer: '本页面会实时更新黑料网的最新可用域名。您可以收藏本页面（按Ctrl+D添加到收藏夹），随时回来查看最新域名。同时，您也可以关注我们的官方社交媒体账号获取域名更新通知。',
  },
  {
    question: '黑料网的域名都是永久有效的吗？',
    answer: '我们会尽最大努力保持域名的稳定性，但由于外部不可控因素，部分域名可能会被限制访问。建议您保存本域名汇总页面，一旦主域名无法访问，可以立即切换到备用域名继续浏览。我们通常保持3-5个活跃域名以确保访问的连续性。',
  },
  {
    question: '黑料网的内容真实性如何保证？',
    answer: '黑料网设有独立的事实核查团队，所有爆料内容在发布前都会经过多轮验证。我们采用多信源交叉验证机制，确保每一条信息都有据可查。对于尚未完全核实的内容，我们会明确标注"待核实"标签，请读者自行判断。',
  },
  {
    question: '如何向黑料网投稿或提供线索？',
    answer: '您可以通过关于我们页面上的联系方式向我们发送投稿或爆料线索。我们会对所有线索进行保密处理，并严格保护爆料人的隐私安全。重大线索一经采用，将给予丰厚奖励。',
  },
];

export const aboutContent = {
  brandIntro: `黑料网成立于2020年，是国内领先的独立资讯爆料平台。我们的团队由资深媒体人、调查记者和技术专家组成，致力于为公众提供真实、深入的资讯内容。

在信息爆炸的时代，真相常常被淹没在海量的信息洪流中。黑料网的使命就是拨开迷雾，还原事实，让公众看到事件的全貌。我们坚持独立、客观、深度的报道原则，不畏强权，不惧压力，只为真相发声。

经过多年的发展，黑料网已建立起覆盖娱乐圈、社会热点、科技数码、财经商业、体育竞技等多个领域的全方位资讯矩阵。我们的原创报道多次引发社会广泛关注和讨论，推动了多项社会议题的进程。`,
  reputation: `黑料网凭借其独立客观的报道立场和深入的调查能力，赢得了广大读者的信任和赞誉。

• 2024年，黑料网被多家第三方机构评为"最具影响力的独立资讯平台"之一
• 平台月活跃用户已突破5000万，日均浏览量超过2000万次
• 多篇独家调查报道被主流媒体转载和跟进，推动了相关事件的有效解决
• 在读者满意度调查中，内容真实性和时效性评分均达到4.8分（满分5分）
• 平台记者团队多次获得行业新闻奖项，调查报道质量获得业界广泛认可

我们的读者评价："黑料网是少数还能看到真话的地方"，"每一次重大事件，我都会先来黑料网看看有没有深度分析"，"感谢黑料网的坚持，让我们看到了很多被掩盖的真相"。`,
  contact: {
    email: 'tips@heiliaowang.com',
    wechat: 'heiliaowang_official',
    weibo: '@黑料网官方',
    address: '中国北京市朝阳区建国路88号SOHO现代城A座',
    phone: '010-8888-6666',
    workingHours: '周一至周五 9:00-18:00',
  },
};